import { render, staticRenderFns } from "./PlantInfo.vue?vue&type=template&id=027a695a&scoped=true"
import script from "./PlantInfo.vue?vue&type=script&lang=ts"
export * from "./PlantInfo.vue?vue&type=script&lang=ts"
import style0 from "./PlantInfo.vue?vue&type=style&index=0&id=027a695a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a695a",
  null
  
)

export default component.exports